export const GET_USER_PILLAR =
  'pages/coach/userManagement/singleUser/plp/getUserPillar'
